export default __webpack_public_path__ + "static/media/CCG_POP.5494145e.png";